export default __webpack_public_path__ + "static/media/1.863e6935.jpg";